"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableRowsPlugin = void 0;
var react_1 = __importDefault(require("react"));
exports.SelectableRowsPlugin = {
    headingRender: function (_a, items) {
        var pluginOptions = _a.pluginOptions;
        if (!pluginOptions) {
            return false;
        }
        var pluginConfig = pluginOptions["selectableRows"];
        if (!pluginConfig || !pluginConfig.canSelectAll) {
            return false;
        }
        var allSelected = items.every(pluginConfig.predicate
            ? function (item) {
                return pluginConfig.selectedValues.some(function (selectedItem) {
                    return pluginConfig.predicate(selectedItem, item);
                });
            }
            : function (item) { return pluginConfig.selectedValues.includes(item[pluginConfig.selectionKey]); });
        var handleOnClick = function () {
            if (pluginConfig.onSelectAll) {
                pluginConfig.onSelectAll(!allSelected);
            }
            else if (allSelected) {
                // Deselect all (i.e. only keep disabled, selected values)
                pluginConfig.onSelection(items
                    .map(function (item) { return item[pluginConfig.selectionKey]; })
                    .filter(function (value) {
                    var _a;
                    return ((_a = pluginConfig.disabledValues) === null || _a === void 0 ? void 0 : _a.includes(value)) &&
                        pluginConfig.selectedValues.includes(value);
                }));
            }
            else {
                // Select all
                pluginConfig.onSelection(items.map(function (item) { return item[pluginConfig.selectionKey]; }));
            }
        };
        if (pluginConfig.selectAllComponent) {
            return (react_1.default.createElement(pluginConfig.selectAllComponent, { onClick: handleOnClick, selected: allSelected }));
        }
        else {
            return (react_1.default.createElement("input", { type: "checkbox", checked: allSelected, onChange: handleOnClick, className: pluginConfig.className }));
        }
    },
    cellRender: function (item, _a) {
        var _b;
        var pluginOptions = _a.pluginOptions;
        if (!pluginOptions) {
            return false;
        }
        var pluginConfig = pluginOptions["selectableRows"];
        if (!pluginConfig) {
            return false;
        }
        var value = item[pluginConfig.selectionKey];
        var selected = pluginConfig.selectedValues.some(function (selectedValue) {
            if (pluginConfig.predicate) {
                return pluginConfig.predicate(selectedValue, item);
            }
            else {
                return selectedValue === value;
            }
        });
        var isDisabled = (_b = pluginConfig.disabledValues) === null || _b === void 0 ? void 0 : _b.includes(value);
        var handleOnClick = function (e) {
            e.stopPropagation();
            if (isDisabled) {
                return;
            }
            var newItems = selected
                ? pluginConfig.selectedValues.filter(function (selectedValue) { return selectedValue !== value; })
                : __spreadArray(__spreadArray([], pluginConfig.selectedValues), [value]);
            pluginConfig.onSelection(newItems);
        };
        if (pluginConfig.component) {
            return (react_1.default.createElement(pluginConfig.component, { item: item, value: value, selected: selected, disabled: isDisabled, onClick: handleOnClick }));
        }
        else {
            return (react_1.default.createElement("input", { type: "checkbox", checked: selected, disabled: isDisabled, onClick: function (e) { return e.stopPropagation(); }, onChange: handleOnClick, className: pluginConfig.className }));
        }
    },
};
//# sourceMappingURL=SelectableRowsPlugin.js.map